var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCze(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0052b4"
    },
    width: 512,
    height: 341.326,
    y: 85.337
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#d80027"
    },
    points: "512 256 512 426.663 0 426.663 215.185 256"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#f0f0f0"
    },
    points: "512 85.337 512 256 215.185 256 0 85.337"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCze);
export default __webpack_public_path__ + "static/media/cze.ef7add648f6c2132ca715cb5a6694f9f.svg";
export { ForwardRef as ReactComponent };